import { __assign, __rest } from "tslib";
import React from 'react';
import { Svg } from '@marvelapp/ui';
export default function LayerFolderOpen(_a) {
    var props = __rest(_a, []);
    return (React.createElement(Svg, __assign({ display: "block", height: "24px", viewBox: "0 0 24 24", width: "24px" }, props),
        React.createElement("path", { d: "M5.88,17.5a.5.5,0,0,1-.49-.44l-.75-6a.47.47,0,0,1,.12-.39.48.48,0,0,1,.37-.17H18.87a.48.48,0,0,1,.37.17.47.47,0,0,1,.12.39l-.75,6a.5.5,0,0,1-.49.44Z", fillRule: "evenodd", opacity: "0.22" }),
        React.createElement("path", { d: "M18.87,11l-.75,6H5.88l-.75-6H18.87m0-1H5.13a1,1,0,0,0-1,1.12l.75,6a1,1,0,0,0,1,.88H18.12a1,1,0,0,0,1-.88l.75-6a1,1,0,0,0-1-1.12Z" }),
        React.createElement("path", { d: "M5.5,10.5V7A.5.5,0,0,1,6,6.5h4a.5.5,0,0,1,.5.5v.5H18a.5.5,0,0,1,.5.5v2.5Z", fillRule: "evenodd", opacity: "0.14" }),
        React.createElement("path", { d: "M10,7V8h8v2H6V7h4m0-1H6A1,1,0,0,0,5,7v4H19V8a1,1,0,0,0-1-1H11a1,1,0,0,0-1-1Z" })));
}
